module.exports = __webpack_public_path__ + "img/maneken_pos_9.95c31e1b.png";